var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotDotDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 12,
    viewBox: "0 0 2 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03 2A1 1 0 101.028.001 1 1 0 001.03 2zm0 5a1 1 0 10-.002-1.999A1 1 0 001.03 7zm0 5a1 1 0 10-.002-1.999A1 1 0 001.03 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotDotDot);
export default __webpack_public_path__ + "static/media/dot-dot-dot.6ff4c7dc125a3a3bc3ac62cede434858.svg";
export { ForwardRef as ReactComponent };